import { ApiError } from "@/core/api/apiTypes";

export const squareConflictMessage = "This Square connection conflicts with an existing connection. To switch Square accounts, disconnect the existing connection first. A Square account can only be linked to one Froppio business in each environment.";

export function isSquareConflict(error: unknown) {
  return error instanceof ApiError && error.Status === 409;
}
